import React from 'react';
import { Lock } from 'lucide-react';
import { trackUpgradeClick } from '../../utils/analytics';

interface BlurredSectionProps {
  isPro: boolean;
  onUpgrade: () => void;
  children: React.ReactNode;
  title?: string;
}

const BlurredSection: React.FC<BlurredSectionProps> = ({ isPro, onUpgrade, children, title }) => {
  if (isPro) {
    return <>{children}</>;
  }

  const source = title ? `blurred_section:${title}` : 'blurred_section';

  return (
    <div className="relative">
      {/* Заблюренный контент */}
      <div
        className="blurred-section-content blur-sm opacity-70 pointer-events-none select-none"
      >
        {children}
      </div>

      {/* Overlay с CTA — стили SentiHype (золотой акцент) */}
      <div
        className="blurred-section-overlay absolute inset-0 flex flex-col items-center justify-center cursor-pointer z-10 rounded-xl"
        onClick={() => {
          trackUpgradeClick(source, 'overlay_click');
          onUpgrade();
        }}
      >
        <div className="text-center p-8 max-w-md">
          <div
            className="blurred-section-lock-wrap w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4"
          >
            <Lock className="w-8 h-8 text-brand-gold" />
          </div>
          <h3 className="text-xl font-semibold text-white mb-2">
            {title || 'Upgrade to Premium'}
          </h3>
          <p className="text-white/70 mb-6">
            Unlock this feature with a Premium subscription. Click to learn more.
          </p>
          <button
            onClick={(e) => {
              e.stopPropagation();
              trackUpgradeClick(source, 'button_click');
              onUpgrade();
            }}
            className="btn btn-gold px-6 py-3 font-semibold rounded-lg"
          >
            Upgrade to Premium
          </button>
        </div>
      </div>
    </div>
  );
};

export default BlurredSection;
